// extracted by mini-css-extract-plugin
module.exports = {"speakerModal":"SpeakerModal_speakerModal__1EYzt","arrowLeft":"SpeakerModal_arrowLeft__2uHso","arrowRight":"SpeakerModal_arrowRight__28PzD","btns":"SpeakerModal_btns__156DZ"};